var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import WhatsappEnrichmentTermsOfUse from './WhatsappEnrichmentTermsOfUse.vue';
import Tooltip from '@/components/Tooltip.vue';
import { overmind } from '@/overmind';
import InfosetExportIframeModal from '@/modules/infosets/components/InfosetExportIframeModal.vue';
import InfosetExportModalContainer from '../containers/Exportations/InfosetExportModal.container.vue';
import ModalUserHasNotPermission from '@/components/ModalUserHasNotPermission.vue';
import { findInfoSet } from '@/clients/info_set';
import { hasNewExportModal } from '@/shared/utils/helpers';
let ExportBtnOption = class ExportBtnOption extends Vue {
    constructor() {
        super(...arguments);
        this.loadingInfoSet = false;
        this.showExportModal = false;
        this.showLegacyExportModal = false;
        this.legacyExportFallbackTimer = null;
        this.showHasNotPermissionModal = false;
        this.infoset = null;
    }
    get infosetId() {
        return this.$route.params.infosetId;
    }
    get infosetName() {
        return (this.infoset && this.infoset.name) || '';
    }
    async openExportModal() {
        const infoSetId = this.infosetId;
        if (overmind.actions.users.canOpenExportModal(null)) {
            this.loadingInfoSet = true;
            try {
                const response = await findInfoSet(infoSetId);
                this.infoset = response.data;
                // Gate da feature flag: só as contas liberadas abrem o modal novo
                // (iframe do atlas-reborn). As demais vão direto para o modal antigo,
                // sem piscar o iframe na tela.
                // Um fallback pendente de uma abertura anterior não pode ressuscitar o
                // modal antigo por cima deste.
                this.clearLegacyExportFallback();
                // @ts-ignore TS2349: $auth injetado pelo vue-auth
                if (hasNewExportModal(this.$auth.user())) {
                    this.showExportModal = true;
                }
                else {
                    this.showLegacyExportModal = true;
                }
                overmind.actions.infosets.setCurrentInfosetByID(infoSetId);
            }
            catch (e) {
                console.log(e);
            }
            this.loadingInfoSet = false;
        }
        else {
            this.showHasNotPermissionModal = true;
        }
    }
    /**
     * Rede de segurança do gate: o iframe avisou que esta conta não deve ver o
     * modal novo (sem a flag, /user/me indisponível ou o próprio reborn fora do
     * ar). Fecha o iframe e abre a exportação antiga.
     *
     * O delay espera o QDialog do iframe terminar de sair: abrir o modal antigo
     * no mesmo tick faz os dois disputarem o focus trap e o scroll lock do
     * Quasar.
     */
    fallbackToLegacyExport() {
        this.showExportModal = false;
        this.clearLegacyExportFallback();
        this.legacyExportFallbackTimer = setTimeout(() => {
            this.legacyExportFallbackTimer = null;
            this.showLegacyExportModal = true;
        }, 300);
    }
    clearLegacyExportFallback() {
        if (this.legacyExportFallbackTimer) {
            clearTimeout(this.legacyExportFallbackTimer);
            this.legacyExportFallbackTimer = null;
        }
    }
    beforeDestroy() {
        this.clearLegacyExportFallback();
    }
};
ExportBtnOption = __decorate([
    Component({
        name: 'ExportBtnOption',
        components: {
            WhatsappEnrichmentTermsOfUse,
            Tooltip,
            InfosetExportIframeModal,
            InfosetExportModalContainer,
            ModalUserHasNotPermission,
        },
    })
], ExportBtnOption);
export default ExportBtnOption;
